import * as T from './types'

export default {
    [T.SET_APP_ICON](state, payload) {
        state.icon = payload
    },
    [T.SET_APP_SPLASH](state, payload) {
        state.splashes = payload
    },
    [T.SET_SPLASH_ITEM](state, payload) {
        const { platform, size, data } = payload
        state.splashes[platform][size] = data
    },

    [T.SET_CORDOVA_CONFIG](state, payload) {
        state.cordovaConfig = payload
    },

    [T.SET_IOS_CRED](state, payload) {
        state.iosCred = {
            ...state.iosCred,
            ...payload
        }
    },
    [T.RESET_IOS_CRED](state) {
        state.iosCred = {}
    },
    [T.SET_IOS_CRED_TYPE](state, payload) {
        const { package_type: type, ...other } = payload
        const target = state.iosCred[type] || {}
        const data = {
            [type]: {
                ...target,
                ...other
            }
        }

        state.iosCred = {
            ...state.iosCred,
            ...data
        }
    },
    [T.SET_ANDROID_CRED](state, payload) {
        state.androidCred = {
            ...state.androidCred,
            ...payload
        }
    },
    [T.RESET_ANDROID_CRED](state) {
        state.androidCred = {}
    },

    [T.SET_ENGINE_LSIT](state, payload) {
        state.engines = payload
    },
    [T.SET_CURRENT_ENGINE](state, payload) {
        state.currentEngine = {
            ...state.currentEngine,
            ...payload
        }
    },

    [T.SET_HOOKS](state, payload) {
        state.hooks = payload
    },
    [T.ADD_HOOK](state, payload) {
        const dict = {
            android: 'Android',
            ios: 'iOS',
            global: 'Global'
        }
        const { file, platform, ...x } = payload
        state.hooks.push({ name: file.name, platform: dict[platform], ...x })
    },
    [T.DELETE_HOOK](state, payload) {
        const { name } = payload
        const index = state.hooks.findIndex(hook => hook.name === name)
        if (index > -1) {
            state.hooks.splice(index, 1)
        }
    },

    [T.SET_PLUGIN_STATUS](state, payload) {
        state.pluginStatus = payload
    },

    [T.SET_PLUGIN_LIST](state, payload) {
        state.plugins = payload
    },

    [T.RESET_PLUGIN_LIST](state) {
        state.plugins = []
    },

    [T.SET_PACKAGE_LIST](state, payload) {
        state.buildList = payload
    },
    [T.SET_APP_VERSION](state, payload) {
        state.appVersions = payload
    },
    [T.RESET_PACKAGE_LIST](state) {
        state.buildList = []
    }
}
